import React, { useContext } from 'react';

import ModalsContext from 'src/context/modals.jsx';
import SimpleModal from 'src/berry/ui-component/modals/SimpleModals.jsx';
import ItemDelete from 'src/modals/item_delete.jsx';
import PinForm from 'src/modals/pin_form.jsx';

const big_modal = { width: 'auto', position: 'relative', top: 'unset', left: 'unset', transform: 'none', margin: '50px' };

const _modal2components = new Map([
	['file_delete', { content: <ItemDelete />, title: 'Delete file' }],
	['pin_delete', { content: <ItemDelete />, title: 'Delete pin' }],
	['pin_add', { content: <PinForm action="add" />, title: 'Add pin', styles: big_modal }],
	['pin_edit', { content: <PinForm action="edit" />, title: 'Edit pin', styles: big_modal }],
]);

const Modals = () => {
	const { modal, opened, hide } = useContext(ModalsContext);
	const component = _modal2components.get(modal);

	return <SimpleModal open={opened} on_close={hide} content={component?.content} title={component?.title} styles={component?.styles} />;
};

export default Modals;
